module.exports = __webpack_public_path__ + "static/Compare-Quotes-9bc64cf775f9eed0e126f4c09a153bf8.svg";